var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-locations__result"},[_c('SearchResult',_vm._g({attrs:{"is-popup":true,"result":_vm.result,"show-print":false}},_vm.$listeners))],1)}
var staticRenderFns = []

export { render, staticRenderFns }